import { FC } from 'react';
import { OptimizeNewEdit } from 'modules/frequencyManagement/components/optimize/OptimizeNewEdit';
import { OptimizePendingReview } from 'modules/frequencyManagement/components/optimize/OptimizePendingReview';
import { OptimizeReadyReview } from 'modules/frequencyManagement/components/optimize/OptimizeReadyReview';
import { OptimizePendingEdit } from 'modules/frequencyManagement/components/optimize/OptimizePendingEdit';
import { OptimizeReadyEdit } from 'modules/frequencyManagement/components/optimize/OptimizeReadyEdit';
import { OptimizeBaseProps } from 'modules/frequencyManagement/components/optimize/Optimize.types';
import { HistogramData } from 'modules/frequencyManagement/lib/types';

export const MESSAGE_MEDIUM_OPTIMIZE_INPUT_CARD_ID = 'frequency-medium-optimize-input-card';

export interface OptimizeProps extends OptimizeBaseProps {
  isEditing: boolean;
  optimizeDetails: {
    areResultsReady: boolean;
    histogramData: HistogramData;
    lastUpdated: string;
    hasSavedData: boolean;
  };
}

export const Optimize: FC<OptimizeProps> = ({ isEditing, rootName, optimizeDetails }) => {
  const { areResultsReady, histogramData, lastUpdated, hasSavedData } = optimizeDetails;
  return (
    <>
      {isEditing && !hasSavedData && <OptimizeNewEdit rootName={rootName} />}
      {isEditing && hasSavedData && !areResultsReady && <OptimizePendingEdit rootName={rootName} />}
      {isEditing && hasSavedData && areResultsReady && (
        <OptimizeReadyEdit
          histogramData={histogramData}
          lastUpdated={lastUpdated}
          rootName={rootName}
        />
      )}
      {!isEditing && hasSavedData && !areResultsReady && <OptimizePendingReview />}
      {!isEditing && hasSavedData && areResultsReady && (
        <OptimizeReadyReview
          histogramData={histogramData}
          lastUpdated={lastUpdated}
          rootName={rootName}
        />
      )}
    </>
  );
};
